/* eslint-disable no-unused-vars */
import Vue from 'vue'

class DataUpdater extends Vue {
   constructor(func, events, eventHandler) {
      super();
      this._func = func
      this._m_events = events
      this._eventHandler = eventHandler
      this._registerEvents()
   }

   _registerEvents() {
      this.$bus.$on(this._m_events, ($event, data) => {
         if (this._eventHandler($event, data)) {
            const res = this._func()
            this.$emit('update', res)
         }
      })
   }
}

const du = DataUpdater

export default du
